<template>
  <div class="page_container">
    <div class="total">
      {{ $t("page.num", { num: total }) }}
    </div>
    <div class="page">
      <div
        class="prev"
        :class="currentPage === 1 ? 'disabled' : ''"
        @click="prevFun"
      >
        <img
          :src="
            currentPage === 1
              ? require('@/assets/page/arrow.png')
              : require('@/assets/page/arrow_active.png')
          "
          alt=""
          :class="currentPage !== 1 ? 'turn' : ''"
        />
      </div>
      <div class="page_list">
        <div
          class="item"
          v-for="(item, index) in pageNumbs"
          :class="currentPage === item ? 'active' : ''"
          :key="item"
          @click="changePage(item, index)"
          @mouseenter="itemActive(item, index)"
          @mouseleave="rightActive = leftActive = false"
        >
          <template v-if="(rightActive || leftActive) && activeIndex === index">
            <img
              :src="require('@/assets/page/arrow_active.png')"
              alt=""
              :style="{
                transform: leftActive ? 'rotate(180deg)' : 'rotate(0deg)',
              }"
            />
            <img
              :src="require('@/assets/page/arrow_active.png')"
              alt=""
              :style="{
                transform: leftActive ? 'rotate(180deg)' : 'rotate(0deg)',
              }"
            />
          </template>

          <template v-else>{{ item }}</template>
        </div>
      </div>
      <div
        class="next"
        :class="
          currentPage === pageNumbs[pageNumbs.length - 1] ? 'disabled' : ''
        "
        @click="nextFun"
      >
        <img
          :src="
            currentPage === pageNumbs[pageNumbs.length - 1]
              ? require('@/assets/page/arrow.png')
              : require('@/assets/page/arrow_active.png')
          "
          alt=""
          :class="
            currentPage === pageNumbs[pageNumbs.length - 1] ? '' : 'no_turn'
          "
        />
      </div>
    </div>

    <div class="go">
      <span>{{ $t("page.go") }}</span>
      <input
        type="number"
        @input="
          if (insertPage.length > 3) {
            insertPage = insertPage.slice(0, 3);
          }
        "
        v-model="insertPage"
        @change="insertChange"
      />
      <span>{{ $t("page.page") }}</span>
      <div class="go_btn" @click="goPage">GO</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "live-pagination",
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 60,
    },
    total: {
      type: Number,
      default: 0,
    },
    setPage: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      insertPage: null,
      rightActive: false,
      leftActive: false,
      activeIndex: 0,
    };
  },
  computed: {
    pageNumbs() {
      const totalPage = Math.ceil(this.total / this.pageSize);
      const pageArr = new Array(totalPage).fill(0).map((item, index) => {
        return index + 1;
      });
      let left = [];
      let right = [];
      let middle = [];
      let formatPageList = [];
      if (totalPage > 10) {
        if (this.currentPage < 6) {
          left = pageArr.slice(0, 7);
          right = pageArr.slice(-1);
          formatPageList = [...left, "...", ...right];
        } else if (this.currentPage > totalPage - 6) {
          left = pageArr.slice(0, 1);
          right = pageArr.slice(-7);
          formatPageList = [...left, "...", ...right];
        } else if (this.currentPage >= 6 && this.currentPage <= totalPage - 6) {
          left = pageArr.slice(0, 1);
          right = pageArr.slice(-1);
          middle = pageArr.slice(this.currentPage - 4, this.currentPage + 3);
          formatPageList = [...left, "...", ...middle, "...", ...right];
        }
      } else {
        formatPageList = pageArr;
      }

      return formatPageList;
    },
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    insertChange(e) {
      this.insertPage = Math.trunc(e.target.value);
    },
    changePage(page, index) {
      if (typeof page !== "number") {
        if (index > 6) {
          this.setPage(this.currentPage + 3);
        } else {
          this.setPage(this.currentPage - 3);
        }
      } else {
        if (this.currentPage !== page) {
          this.setPage(page);
        }
      }
    },
    itemActive(page, index) {
      if (typeof page !== "number") {
        this.activeIndex = index;
        if (index > 6) {
          this.rightActive = true;
        } else {
          this.leftActive = true;
        }
      }
    },
    prevFun() {
      if (this.currentPage === 1) return;
      this.setPage(this.currentPage - 1);
    },
    nextFun() {
      if (this.currentPage === this.pageNumbs[this.pageNumbs.length - 1])
        return;
      this.setPage(this.currentPage + 1);
    },
    goPage() {
      if (!this.insertPage) return;
      if (this.insertPage > this.pageNumbs) return;
      if (this.insertPage === this.currentPage) return;
      this.setPage(this.insertPage);

      this.insertPage = null;
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.page_container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .total {
    font-size: 12px;
    color: rgba(96, 98, 102, 1);
  }
  .page {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 30px;
    .prev,
    .next {
      width: 30px;
      height: 30px;
      border-radius: 4px;
      background: rgba(244, 244, 245, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        width: 12px;
        height: 12px;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }
    .prev {
      img {
        &.turn {
          transform: rotate(180deg);
        }
      }
    }
    .next {
      img {
        transform: rotate(180deg);
        &.no_turn {
          transform: rotate(0deg);
        }
      }
    }
    .page_list {
      display: flex;
      justify-content: center;
      align-items: center;
      .item {
        width: 30px;
        height: 30px;
        border-radius: 4px;
        background: rgba(244, 244, 245, 1);
        color: rgba(96, 98, 102, 1);
        font-size: 12px;
        text-align: center;
        line-height: 30px;
        margin: 0 8px;
        cursor: pointer;
        &.active {
          background: rgba(208, 45, 84, 1);
          color: #fff;
        }
        img {
          width: 12px;
          height: 12px;
          &:last-child {
            margin-left: -8px;
          }
        }
      }
    }
  }
  .go {
    display: flex;
    align-items: center;
    input {
      width: 46px;
      height: 26px;
      border-radius: 4px;
      border: 1px solid rgba(219, 219, 219, 1);
      color: rgba(152, 153, 154, 1);
      text-align: center;
      margin: 0 5px;
    }
    .go_btn {
      width: 40px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background: rgba(208, 45, 84, 1);
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
      margin-left: 14px;
    }
  }
}
</style>
